"use strict";
'use client';

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CtaButton = void 0;
var _classnames = _interopRequireDefault(require("classnames"));
var _react = _interopRequireWildcard(require("react"));
var _Button = require("../../../elements/button/Button");
var _visuallyHiddenModule = _interopRequireDefault(require("../../../style/display/visually-hidden.module.scss"));
var _basket = require("../../../utils/basket/basket");
var _OpenMiniBasket = require("../../../utils/basket/OpenMiniBasket");
var _getProductUrl = _interopRequireDefault(require("../../../utils/product/getProductUrl"));
var _AddToBasketButton = _interopRequireDefault(require("../../add-to-basket-button/AddToBasketButton"));
var _ctaButtonModule = _interopRequireDefault(require("./cta-button.module.scss"));
var _displayLogic = require("./displayLogic");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
var CtaButton = exports.CtaButton = function CtaButton(_ref) {
  var _ref$atbProps = _ref.atbProps,
    atbProps = _ref$atbProps === void 0 ? {} : _ref$atbProps,
    className = _ref.className,
    emailConfirmed = _ref.emailConfirmed,
    handleQuickAddClick = _ref.handleQuickAddClick,
    handleQuickViewClick = _ref.handleQuickViewClick,
    _ref$handleMoreInform = _ref.handleMoreInformationClick,
    handleMoreInformationClick = _ref$handleMoreInform === void 0 ? undefined : _ref$handleMoreInform,
    _ref$hasAddToBasketBu = _ref.hasAddToBasketButton,
    hasAddToBasketButton = _ref$hasAddToBasketBu === void 0 ? true : _ref$hasAddToBasketBu,
    _ref$hasEmailMeWhenAv = _ref.hasEmailMeWhenAvailableButton,
    hasEmailMeWhenAvailableButton = _ref$hasEmailMeWhenAv === void 0 ? true : _ref$hasEmailMeWhenAv,
    _ref$hasGoToBasketBut = _ref.hasGoToBasketButton,
    hasGoToBasketButton = _ref$hasGoToBasketBut === void 0 ? true : _ref$hasGoToBasketBut,
    _ref$hasInStoreOnlyBu = _ref.hasInStoreOnlyButton,
    hasInStoreOnlyButton = _ref$hasInStoreOnlyBu === void 0 ? true : _ref$hasInStoreOnlyBu,
    _ref$hasMoreInformati = _ref.hasMoreInformationButton,
    hasMoreInformationButton = _ref$hasMoreInformati === void 0 ? true : _ref$hasMoreInformati,
    _ref$hasOosButton = _ref.hasOosButton,
    hasOosButton = _ref$hasOosButton === void 0 ? true : _ref$hasOosButton,
    hasShortCtaText = _ref.hasShortCtaText,
    isAddedToBasket = _ref.isAddedToBasket,
    _ref$isMoreInformatio = _ref.isMoreInformationButtonPrimary,
    isMoreInformationButtonPrimary = _ref$isMoreInformatio === void 0 ? false : _ref$isMoreInformatio,
    moreInformationCustomLabel = _ref.moreInformationCustomLabel,
    product = _ref.product,
    productUrl = _ref.productUrl,
    _ref$quickViewBundleL = _ref.quickViewBundleLoading,
    quickViewBundleLoading = _ref$quickViewBundleL === void 0 ? false : _ref$quickViewBundleL,
    selectedSwatch = _ref.selectedSwatch,
    _ref$showViewOptions = _ref.showViewOptions,
    showViewOptions = _ref$showViewOptions === void 0 ? false : _ref$showViewOptions,
    swatchOrder = _ref.swatchOrder,
    swatchOverride = _ref.swatchOverride;
  var adId = product.adId,
    id = product.id,
    isMultiSku = product.isMultiSku,
    isShipFromStore = product.isShipFromStore,
    skuId = product.skuId,
    title = product.title,
    variantId = product.variantId;
  var _useState = (0, _react.useState)(false),
    _useState2 = _slicedToArray(_useState, 2),
    isLoading = _useState2[0],
    setIsLoading = _useState2[1];
  var hasProductJustBeenAddedToBasket = (0, _react.useRef)(false);
  var ADD_TO_BASKET = 'plp.addToBasket';
  var handleBasketChange = function handleBasketChange(event) {
    var _event$detail, _event$detail2;
    if (((_event$detail = event.detail) === null || _event$detail === void 0 ? void 0 : _event$detail.action) !== ADD_TO_BASKET) {
      return;
    }
    var productAddedToBasket = (_event$detail2 = event.detail) === null || _event$detail2 === void 0 ? void 0 : _event$detail2.products;
    if ((productAddedToBasket === null || productAddedToBasket === void 0 ? void 0 : productAddedToBasket.productId) === id) {
      hasProductJustBeenAddedToBasket.current = true;
    }
  };
  (0, _react.useEffect)(function () {
    document.body.addEventListener('dataStateChange', handleBasketChange);
    return function () {
      document.body.removeEventListener('dataStateChange', handleBasketChange);
    };
  }, []);
  (0, _react.useEffect)(function () {
    if (hasProductJustBeenAddedToBasket.current && isAddedToBasket) {
      var gtbButtonEl = document.querySelector("[data-product-id=\"".concat(id, "\"] [data-testid=\"component-go-to-basket-button\"]"));
      if (gtbButtonEl) {
        gtbButtonEl.focus();
      }
    }
    hasProductJustBeenAddedToBasket.current = false;
  }, [isAddedToBasket]);
  var btnSize = 'small';
  var moreInformationLabel = moreInformationCustomLabel ? moreInformationCustomLabel : (product === null || product === void 0 ? void 0 : product.type) === 'productSet' ? 'View range' : 'More information';
  var MoreInformationButton = isMoreInformationButtonPrimary ? _Button.PrimaryButton : _Button.SecondaryButton;
  var handleMultiSkuSelection = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
      return _regenerator().w(function (_context) {
        while (1) switch (_context.n) {
          case 0:
            setIsLoading(true);
            _context.n = 1;
            return Promise.resolve(window.innerWidth < 768 && handleQuickAddClick ? handleQuickAddClick(id, productUrl, swatchOrder, swatchOverride === null || swatchOverride === void 0 ? void 0 : swatchOverride.color, adId, false, 'ADD_TO_BASKET') : handleQuickViewClick(id, selectedSwatch.url || (0, _getProductUrl.default)(title, id, selectedSwatch), swatchOrder, swatchOverride === null || swatchOverride === void 0 ? void 0 : swatchOverride.color, adId, false, 'ADD_TO_BASKET'));
          case 1:
            setIsLoading(false);
          case 2:
            return _context.a(2);
        }
      }, _callee);
    }));
    return function handleMultiSkuSelection() {
      return _ref2.apply(this, arguments);
    };
  }();
  if ((0, _displayLogic.shouldShowViewOptionsButton)(product, showViewOptions)) {
    return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_Button.SecondaryButton, {
      className: (0, _classnames.default)(className, _ctaButtonModule.default['cta-button']),
      "data-testid": "component-view-option-button",
      disabled: isLoading,
      href: productUrl,
      size: btnSize,
      submitting: isLoading,
      tag: "a",
      children: ["View options", /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
        className: _visuallyHiddenModule.default.visuallyHidden,
        children: ", ".concat(title)
      })]
    }, "view-options");
  }
  if ((0, _displayLogic.shouldShowInStoreOnly)(product, hasInStoreOnlyButton)) {
    return /*#__PURE__*/(0, _jsxRuntime.jsx)(_Button.PrimaryButton, {
      className: (0, _classnames.default)(className, _ctaButtonModule.default['cta-button']),
      "data-testid": "In Store Only Button",
      disabled: true,
      href: productUrl,
      size: btnSize,
      tag: "a",
      children: "In-store only"
    }, "in-store-only");
  }
  if ((0, _displayLogic.shouldShowPermanentOOSButton)(product, hasOosButton)) {
    return /*#__PURE__*/(0, _jsxRuntime.jsx)(_Button.PrimaryButton, {
      className: (0, _classnames.default)(className, _ctaButtonModule.default['cta-button']),
      "data-testid": "Out Of Stock Button",
      disabled: true,
      href: productUrl,
      size: btnSize,
      tag: "a",
      children: "Out of stock"
    }, "oos");
  }
  if ((0, _displayLogic.shouldShowEmwbisButton)(product, hasEmailMeWhenAvailableButton) && !emailConfirmed) {
    return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_Button.SecondaryButton, {
      className: (0, _classnames.default)(className, _ctaButtonModule.default['cta-button']),
      "data-testid": "component-email-bis-button",
      disabled: isLoading,
      onClick: handleMultiSkuSelection,
      size: btnSize,
      submitting: isLoading,
      children: ["Email when available", /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
        className: _visuallyHiddenModule.default.visuallyHidden,
        children: ", ".concat(title)
      })]
    }, "email-me");
  }
  if ((0, _displayLogic.shouldShowEmwbisButton)(product, hasEmailMeWhenAvailableButton) && emailConfirmed) {
    return /*#__PURE__*/(0, _jsxRuntime.jsx)(_Button.SecondaryButton, {
      className: (0, _classnames.default)(className, _ctaButtonModule.default['cta-button']),
      "data-testid": "We will be in touch Button",
      href: productUrl,
      size: btnSize,
      tag: "a",
      children: "We'll be in touch"
    }, "well-be-in-touch");
  }
  if ((0, _displayLogic.shouldShowAddToBasketButton)(product, hasAddToBasketButton) && (!isAddedToBasket || (0, _basket.isBasketPageType)())) {
    return /*#__PURE__*/(0, _react.createElement)(_AddToBasketButton.default, _objectSpread(_objectSpread({}, atbProps), {}, {
      key: "atb",
      "aria-label": "Add ".concat(title, " to your basket"),
      className: (0, _classnames.default)(className, _ctaButtonModule.default['cta-button']),
      "data-testid": atbProps['data-testid'] || isMultiSku ? 'multi sku add to basket' : 'add to basket',
      forceLoading: isLoading || isMultiSku && quickViewBundleLoading,
      hasHeaderBasketCountEvent: !isMultiSku,
      sendToBasket: isMultiSku ? handleMultiSkuSelection : atbProps.sendToBasket,
      shortCtaText: hasShortCtaText,
      size: btnSize,
      skuId: skuId,
      title: title,
      variantId: variantId
    }));
  }
  if ((0, _displayLogic.shouldShowAddToBasketButton)(product, hasAddToBasketButton) && isAddedToBasket && hasGoToBasketButton && !(0, _basket.isBasketPageType)()) {
    return /*#__PURE__*/(0, _jsxRuntime.jsx)(_Button.SecondaryButton, {
      "aria-label": "".concat(title, " is in your basket. Go to basket"),
      className: (0, _classnames.default)(className, _ctaButtonModule.default['cta-button']),
      "data-testid": "component-go-to-basket-button",
      href: "/basket",
      onClick: _OpenMiniBasket.openMiniBasket,
      size: btnSize,
      tag: "a",
      children: "Go to".concat(hasShortCtaText ? '' : ' your', " basket")
    }, "gtb");
  }
  if (hasMoreInformationButton) {
    return /*#__PURE__*/(0, _jsxRuntime.jsxs)(MoreInformationButton, {
      className: (0, _classnames.default)(className, _ctaButtonModule.default['cta-button']),
      "data-test-ship-from-store": isShipFromStore,
      "data-testid": "More Information Button",
      href: productUrl,
      onClick: handleMoreInformationClick,
      size: btnSize,
      tag: "a",
      children: [moreInformationLabel, /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
        className: _visuallyHiddenModule.default.visuallyHidden,
        children: ", ".concat(title)
      })]
    }, "more-info");
  }
  return null;
};